import React from 'react'
import TextField from './../../shared/components/fields/textField/TextField';
import { I18n } from 'react-redux-i18n';
import SelectField from "../../shared/components/fields/selectField/SelectField";
import Alert from '../../shared/components/alerts/Alert';
import FormButtons from "../../shared/components/others/formButtons/FormButtons";
import TerminalViewForm from "./TerminalViewForm";
import { appModules } from '../../roles/components/UserHasPermission';

const TerminalsForm = ({
    terminalFormData: {
        id,
        terminalIdentifier,
        name,
        profile,
        entity,
        allowAutoProvisioning,
        keepAliveTimeMinutes,
        status,
        lastCommunication,
        online,
        location = {},
        enabled,
    },
    alert,
    editMode,
    createMode,
    viewMode,
    entityList,
    terminalProfilesList,
    entityWithName,
    handleFieldChange,
    handleOnFieldBlur,
    handleSubmitClick,
    handleBackClick,
    handleEditClick,
    handleDeleteClick,
    history,
}) => {
    return <div>
        {createMode || editMode ? <div className="form-container">
            <div className="form">
                <Alert
                    {...alert}
                />
                <div className="header">
                    {buildHeader(createMode, editMode, viewMode)}
                </div>
                <div className="fields">
                    <div id="terminal-fields-1" className="field-row">
                        <div className="row">
                            <TextField
                                value={terminalIdentifier.value}
                                label={I18n.t("terminals.form.terminalIdentifier.label")}
                                handleFieldChange={value => handleFieldChange("terminalIdentifier", value)}
                                handleFieldBlur={() => handleOnFieldBlur("terminalIdentifier")}
                                themeName="form"
                                error={terminalIdentifier.error}
                                disabled={viewMode || editMode}
                                width={4}
                            />
                            <TextField
                                value={name.value}
                                label={I18n.t("terminals.form.name.label")}
                                handleFieldChange={value => handleFieldChange("name", value)}
                                handleFieldBlur={() => handleOnFieldBlur("name")}
                                themeName="form"
                                error={name.error}
                                disabled={viewMode}
                                width={4}
                            />
                        </div>
                        <div className="row">
                            <SelectField
                                handleFieldChange={value => handleFieldChange("entity", value)}
                                value={entity.value}
                                label={I18n.t("terminals.form.entity.label")}
                                options={entityList}
                                error={entity.error}
                                disabled={viewMode}
                                width={4}
                            />
                            <SelectField
                                value={profile.value}
                                label={I18n.t("terminals.form.profile.label")}
                                handleFieldChange={value => handleFieldChange("profile", value)}
                                options={terminalProfilesList}
                                error={profile.error}
                                disabled={viewMode || editMode}
                                width={4}
                            />
                        </div>
                        <div className="row">
                            <SelectField
                                value={allowAutoProvisioning.value}
                                label={I18n.t("terminals.form.allowAutoProvisioning.label")}
                                handleFieldChange={value => handleFieldChange("allowAutoProvisioning", value)}
                                options={[
                                    { value: true, label: I18n.t("terminals.allowAutoProvisioning.yes") },
                                    { value: false, label: I18n.t("terminals.allowAutoProvisioning.no") }
                                ]}
                                error={allowAutoProvisioning.error}
                                disabled={viewMode}
                                width={4}
                            />
                            <TextField
                                value={keepAliveTimeMinutes.value}
                                label={I18n.t("terminals.form.keepAliveTime.label")}
                                handleFieldChange={value => handleFieldChange("keepAliveTimeMinutes", value)}
                                handleFieldBlur={() => handleOnFieldBlur("keepAliveTimeMinutes")}
                                themeName="form"
                                error={keepAliveTimeMinutes.error}
                                disabled={viewMode}
                                width={4}
                            />
                        </div>
                        <div className="row">
                            <SelectField
                                value={enabled.value}
                                label={I18n.t("terminals.form.enabled.label")}
                                handleFieldChange={value => handleFieldChange("enabled", value)}
                                options={[{
                                    value: true,
                                    label: I18n.t("terminals.status.enabled")
                                }, {
                                    value: false,
                                    label: I18n.t("terminals.status.disabled")
                                }]}
                                error={enabled.error}
                                disabled={viewMode}
                                width={4}
                            />
                        </div>
                    </div>
                </div>
                {(createMode || editMode) &&
                    <div className="buttons">
                        <button
                            className=" mt-3 btn btn-primary"
                            onClick={handleSubmitClick}
                        >
                            {I18n.t("forms.save")}
                        </button>
                    </div>}
            </div>
            <div className="form-options">
                <FormButtons
                    editMode={editMode}
                    viewMode={viewMode}
                    handleBackClick={handleBackClick}
                    handleEditClick={handleEditClick}
                    handleDeleteClick={handleDeleteClick}
                    appModule={appModules.TERMINAL}
                />
            </div>
        </div> :
            <TerminalViewForm
                terminalId={id}
                terminalIdentifier={terminalIdentifier}
                name={name}
                profile={profile}
                entity={entity}
                allowAutoProvisioning={allowAutoProvisioning}
                keepAliveTime={keepAliveTimeMinutes}
                status={status}
                lastCommunication={lastCommunication}
                location={location}
                online={online}
                entityList={entityList}
                entityWithName={entityWithName}
                alert={alert}
                editMode={editMode}
                createMode={createMode}
                viewMode={viewMode}
                terminalProfilesList={terminalProfilesList}
                handleFieldChange={handleFieldChange}
                handleOnFieldBlur={handleOnFieldBlur}
                handleSubmitClick={handleSubmitClick}
                handleBackClick={handleBackClick}
                handleEditClick={handleEditClick}
                handleDeleteClick={handleDeleteClick}
                history={history}
            />
        }
    </div>
};

function buildHeader(createMode, editMode) {
    return createMode ?
        I18n.t("terminals.form.headers.create") :
        editMode ?
            I18n.t("terminals.form.headers.edit") :
            I18n.t("terminals.form.headers.view");
}

export default TerminalsForm;